import React from 'react';
import Stack from 'src/app/atoms/Layout/Stack/Stack';
import Typography from 'src/app/atoms/Typography/Typography';
import HelpCircleHint from '../HelpCircleHint/HelpCircleHint';

export interface RevenueCalculatorResultMetricProps {
  label: string;
  value: string;
  hint?: string;
  hintColor?: string;
}

const RevenueCalculatorResultMetric = ({
  label,
  value,
  hint,
  hintColor,
}: RevenueCalculatorResultMetricProps): JSX.Element => {
  return (
    <Stack
      direction='column'
      justify='center'
      align='center'
    >
      <Stack
        direction='row'
        gap='spacing-sm'
        align='center'
        justify='center'
      >
        <Typography
          text={label}
          type='paragraph'
          size='sm'
          fontWeight='font-weight-medium'
          textAlign='center'
        />
        {hint && (
          <HelpCircleHint
            hint={hint}
            id={`${label}-hint`}
            color={hintColor}
          />
        )}
      </Stack>
      <Typography
        text={value}
        type='heading'
        size='sm'
        as='p'
        fontWeight='font-weight-semibold'
        textAlign='center'
      />
    </Stack>
  );
};

export default RevenueCalculatorResultMetric;
